var map = {
	"./AboutCompanySubmenu.vue": "99dd",
	"./AlertLoading.vue": "c0ac",
	"./BlockDocuments.vue": "a266",
	"./Breadcrumbs.vue": "f1b0",
	"./ButtonUp.vue": "53e3",
	"./CardLogo.vue": "9cd8",
	"./CardManagement.vue": "9bdf",
	"./CardNews.vue": "db22",
	"./CardsNews.vue": "c239",
	"./CardsWithNumbers.vue": "96a1",
	"./CardsWithSlogan.vue": "6005",
	"./CardsWithSloganMobile.vue": "72bb",
	"./Child.vue": "1ff61",
	"./ContentDocuments.vue": "ac15",
	"./ContentFrame.vue": "9135",
	"./ContentImage.vue": "68ee7",
	"./ContentNumeric.vue": "ddf9",
	"./ContentText.vue": "ff49",
	"./CookieBanner.vue": "7fe6",
	"./ErrorDialog.vue": "8d74",
	"./FeedbackForm.vue": "633b",
	"./Footer.vue": "c4e9",
	"./FooterIconText.vue": "353a",
	"./FooterImgLinks.vue": "ce10",
	"./IconBtn.vue": "1ece",
	"./IconBtnMobile.vue": "19b0",
	"./IconText.vue": "31eb",
	"./ImgContent.vue": "f502",
	"./ImgNews.vue": "d673",
	"./LicenseSlide.vue": "4cab",
	"./LicenseSlider.vue": "595e",
	"./Loading.vue": "866a",
	"./Locale.vue": "2106",
	"./MainSlider.vue": "73bd",
	"./MainSliderSlide.vue": "ada8",
	"./NumbersMobile.vue": "3e84",
	"./OfferGoodsForm.vue": "c086",
	"./PartnershipSubmenu.vue": "d3db",
	"./PostForm.vue": "c5de",
	"./ProductInstruction.vue": "a5ca",
	"./ProductPost.vue": "2658",
	"./ProductPosts.vue": "fc19",
	"./ProductSertificate.vue": "f7d3",
	"./ProductsSubmenu.vue": "232f",
	"./PushLink.vue": "641b",
	"./ReportForm.vue": "64a5",
	"./SVGLinkText.vue": "df85",
	"./SliderEN.vue": "c0b8",
	"./SliderProducts.vue": "b318",
	"./SliderRU.vue": "623d",
	"./Submenu.vue": "d7dd",
	"./TextHref.vue": "95ac",
	"./ToolBar.vue": "0102",
	"./TooltipContent.vue": "9310",
	"./WorkForm.vue": "ba42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3c5";